import { useState } from 'react';
import { JobExpensesReceipts } from './JobExpensesReceipts';
import { JobCardFieldsCard } from './JobCardFieldsCard';

interface JobDetailExpensesProps {
  jobId: string;
}

type ExpensesSubTab = 'receipts' | 'labor';

const SUB_TABS: { id: ExpensesSubTab; label: string }[] = [
  { id: 'receipts', label: 'Receipts' },
  { id: 'labor', label: 'Labor & Reimbursement' },
];

/**
 * Host for the Expenses tab. Splits the two distinct workflows — logging
 * receipts vs. setting the job card's labor/reimbursement fields — into
 * sibling sub-tabs so neither crowds the other.
 */
export function JobDetailExpenses({ jobId }: JobDetailExpensesProps) {
  const [subTab, setSubTab] = useState<ExpensesSubTab>('receipts');

  return (
    <div className="py-4">
      {/* "Labor & Reimbursement" at its natural width pushes the pair past a
          390px screen; below `sm` the two pills share the row instead. */}
      <div className="mb-4 flex rounded-lg bg-gray-200 p-1 sm:inline-flex">
        {SUB_TABS.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setSubTab(tab.id)}
            className={`inline-flex flex-1 items-center justify-center rounded-md px-3 py-2 text-sm font-medium transition-colors sm:flex-none sm:justify-start sm:py-1.5 ${
              subTab === tab.id
                ? 'bg-white text-gray-900 shadow-sm'
                : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {subTab === 'receipts' ? (
        <JobExpensesReceipts jobId={jobId} />
      ) : (
        <JobCardFieldsCard jobId={jobId} />
      )}
    </div>
  );
}
